<!--
  Vue wrapper for Bryntum DatePicker
-->

<template>

</template>

<script>

import { Base, DatePicker, Layout, Mask, Model, Month, Rectangle, Scroller, Widget } from '@bryntum/scheduler';

import WrapperHelper from './WrapperHelper.js';
import WrapperHelperVue2 from './WrapperHelperVue2.js';

export default {

    name : 'BryntumDatePicker',

    props : {

         // Configs only
        activeDate            : { type : Date, default : undefined },
        adopt                 : { type : [HTMLElement, String], default : undefined },
        align                 : { type : [Object, String], default : undefined },
        anchor                : { type : Boolean, default : undefined },
        appendTo              : { type : [HTMLElement, String], default : undefined },
        bbar                  : { type : [Array, Object], default : undefined },
        bodyCls               : { type : [String, Object], default : undefined },
        cellRenderer          : { type : Function, default : undefined },
        centered              : { type : Boolean, default : undefined },
        cls                   : { type : [String, Object], default : undefined },
        config                : { type : Object, default : undefined },
        constrainTo           : { type : [HTMLElement, Widget, Rectangle], default : undefined },
        contentElementCls     : { type : [String, Object], default : undefined },
        dayNameFormat         : { type : String, default : undefined },
        defaultBindProperty   : { type : String, default : undefined },
        defaults              : { type : Object, default : undefined },
        disabledDates         : { type : [Function, Array], default : undefined },
        disableWeekends       : { type : Boolean, default : undefined },
        dock                  : { type : String, default : undefined },
        draggable             : { type : [Boolean, Object], default : undefined },
        editMonth             : { type : Boolean, default : undefined },
        editOnHover           : { type : Boolean, default : undefined },
        floating              : { type : Boolean, default : undefined },
        focusDisabledDates    : { type : Boolean, default : undefined },
        footer                : { type : [Object, String], default : undefined },
        header                : { type : [String, Object], default : undefined },
        headerRenderer        : { type : Function, default : undefined },
        hideAnimation         : { type : [Boolean, Object], default : undefined },
        hideWhenEmpty         : { type : Boolean, default : undefined },
        htmlCls               : { type : [String, Object], default : undefined },
        insertBefore          : { type : [HTMLElement, String], default : undefined },
        insertFirst           : { type : [HTMLElement, String], default : undefined },
        itemCls               : { type : String, default : undefined },
        lazyItems             : { type : [Object, Array], default : undefined },
        listeners             : { type : Object, default : undefined },
        localeClass           : { type : Base, default : undefined },
        localizableProperties : { type : Array, default : undefined },
        maskDefaults          : { type : [Object, Mask], default : undefined },
        masked                : { type : [Boolean, String, Object, Mask], default : undefined },
        maxDate               : { type : Date, default : undefined },
        minColumnWidth        : { type : Number, default : undefined },
        minDate               : { type : Date, default : undefined },
        minRowHeight          : { type : Number, default : undefined },
        monitorResize         : { type : Boolean, default : undefined },
        month                 : { type : [Month, Object], default : undefined },
        multiSelect           : { type : Boolean, default : undefined },
        namedItems            : { type : Object, default : undefined },
        nonWorkingDays        : { type : Object, default : undefined },
        owner                 : { type : Widget, default : undefined },
        positioned            : { type : Boolean, default : undefined },
        preventTooltipOnTouch : { type : Boolean, default : undefined },
        ripple                : { type : [Boolean, Object], default : undefined },
        rootElement           : { type : ShadowRoot, default : undefined },
        scrollAction          : { type : String, default : undefined },
        showAnimation         : { type : [Boolean, Object], default : undefined },
        showWeekColumn        : { type : Boolean, default : undefined },
        showWeekNumber        : { type : Boolean, default : undefined },
        sixWeeks              : { type : Boolean, default : undefined },
        strips                : { type : Object, default : undefined },
        tab                   : { type : [Boolean, Object], default : undefined },
        tag                   : { type : String, default : undefined },
        tbar                  : { type : [Array, Object], default : undefined },
        textAlign             : { type : String, default : undefined },
        textContent           : { type : Boolean, default : undefined },
        tip                   : { type : Object, default : undefined },
        title                 : { type : String, default : undefined },
        trapFocus             : { type : Boolean, default : undefined },
        weekRenderer          : { type : Function, default : undefined },
        weekStartDay          : { type : Number, default : undefined },
        weight                : { type : Number, default : undefined },

         // Configs and properties
        alignSelf   : { type : [String], default : undefined },
        content     : { type : [String], default : undefined },
        dataset     : { type : [Object], default : undefined },
        date        : { type : [Date], default : undefined },
        disabled    : { type : [Boolean], default : undefined },
        extraData   : { type : [Boolean, Number, Object, String], default : undefined },
        flex        : { type : [Number, String], default : undefined },
        height      : { type : [Number, String], default : undefined },
        hidden      : { type : [Boolean], default : undefined },
        html        : { type : [String], default : undefined },
        id          : { type : [String], default : undefined },
        items       : { type : [Array, Object], default : undefined },
        layout      : { type : [Layout, String], default : undefined },
        layoutStyle : { type : [Object], default : undefined },
        margin      : { type : [Number, String], default : undefined },
        maxHeight   : { type : [Number, String], default : undefined },
        maxWidth    : { type : [Number, String], default : undefined },
        minHeight   : { type : [Number, String], default : undefined },
        minWidth    : { type : [Number, String], default : undefined },
        readOnly    : { type : [Boolean], default : undefined },
        scrollable  : { type : [Boolean, Scroller, Object], default : undefined },
        tools       : { type : [Object], default : undefined },
        tooltip     : { type : [Object, String], default : undefined },
        width       : { type : [Number, String], default : undefined },
        x           : { type : [Number], default : undefined },
        y           : { type : [Number], default : undefined },

         // Properties only
        anchorSize      : { type : Array, default : undefined },
        isSettingValues : { type : Boolean, default : undefined },
        isValid         : { type : Boolean, default : undefined },
        record          : { type : Model, default : undefined },
        values          : { type : Object, default : undefined },

         // Events
        onBeforeDestroy   : { type : Function, default : undefined },
        onBeforeHide      : { type : Function, default : undefined },
        onBeforeSetRecord : { type : Function, default : undefined },
        onBeforeShow      : { type : Function, default : undefined },
        onCatchAll        : { type : Function, default : undefined },
        onDateChange      : { type : Function, default : undefined },
        onDestroy         : { type : Function, default : undefined },
        onFocusIn         : { type : Function, default : undefined },
        onFocusOut        : { type : Function, default : undefined },
        onHide            : { type : Function, default : undefined },
        onPaint           : { type : Function, default : undefined },
        onReadOnly        : { type : Function, default : undefined },
        onRefresh         : { type : Function, default : undefined },
        onResize          : { type : Function, default : undefined },
        onSelectionChange : { type : Function, default : undefined },
        onShow            : { type : Function, default : undefined },
        onToolClick       : { type : Function, default : undefined },

    },

    data : () => {
        return {
            instanceClass : DatePicker,

            configNames : [
                'activeDate',
                'adopt',
                'align',
                'anchor',
                'appendTo',
                'bbar',
                'bodyCls',
                'cellRenderer',
                'centered',
                'cls',
                'config',
                'constrainTo',
                'contentElementCls',
                'dayNameFormat',
                'defaultBindProperty',
                'defaults',
                'disabledDates',
                'disableWeekends',
                'dock',
                'draggable',
                'editMonth',
                'editOnHover',
                'floating',
                'focusDisabledDates',
                'footer',
                'header',
                'headerRenderer',
                'hideAnimation',
                'hideWhenEmpty',
                'htmlCls',
                'insertBefore',
                'insertFirst',
                'itemCls',
                'lazyItems',
                'listeners',
                'localeClass',
                'localizableProperties',
                'maskDefaults',
                'masked',
                'maxDate',
                'minColumnWidth',
                'minDate',
                'minRowHeight',
                'monitorResize',
                'month',
                'multiSelect',
                'namedItems',
                'nonWorkingDays',
                'owner',
                'positioned',
                'preventTooltipOnTouch',
                'ripple',
                'rootElement',
                'scrollAction',
                'showAnimation',
                'showWeekColumn',
                'showWeekNumber',
                'sixWeeks',
                'strips',
                'tab',
                'tag',
                'tbar',
                'textAlign',
                'textContent',
                'tip',
                'title',
                'trapFocus',
                'weekRenderer',
                'weekStartDay',
                'weight'
            ],

            propertyConfigNames : [
                'alignSelf',
                'content',
                'dataset',
                'date',
                'disabled',
                'extraData',
                'flex',
                'height',
                'hidden',
                'html',
                'id',
                'items',
                'layout',
                'layoutStyle',
                'margin',
                'maxHeight',
                'maxWidth',
                'minHeight',
                'minWidth',
                'onBeforeDestroy',
                'onBeforeHide',
                'onBeforeSetRecord',
                'onBeforeShow',
                'onCatchAll',
                'onDateChange',
                'onDestroy',
                'onFocusIn',
                'onFocusOut',
                'onHide',
                'onPaint',
                'onReadOnly',
                'onRefresh',
                'onResize',
                'onSelectionChange',
                'onShow',
                'onToolClick',
                'readOnly',
                'scrollable',
                'tools',
                'tooltip',
                'width',
                'x',
                'y'
            ],

            propertyNames : [
                'anchorSize',
                'isSettingValues',
                'isValid',
                'record',
                'values'
            ],

            eventNames : [
                'beforeDestroy',
                'beforeHide',
                'beforeSetRecord',
                'beforeShow',
                'catchAll',
                'dateChange',
                'destroy',
                'focusIn',
                'focusOut',
                'hide',
                'paint',
                'refresh',
                'resize',
                'selectionChange',
                'show',
                'toolClick'
            ]
        };
    },

    /**
     * Called after the instance has been mounted
     */
    mounted() {
        const
            me = this,
            {
                createWidget,
                relayStores,
                watchProps
            }  = WrapperHelper(),
            {
                processCellContent,
                hasFrameworkRenderer
            }  = WrapperHelperVue2();

        me.instance = createWidget({
            me,
            props   : me.$props,
            data    : me.$data,
            emit    : me.$emit.bind(me),
            element : me.$el
        });

        const watcher = me.$watch.bind(me);
        watchProps(me, me.instance, me.$props, me.$data, watcher);
    },

    /**
     * Called right before a Vue instance is destroyed. At this stage the instance is still fully functional.
     */
    beforeDestroy() {
        if (this.instance) {
            this.instance.destroy();
        }
    }

};

</script>
